import { Component, Input, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { CompanyStore } from "src/app/core/services/Stores/branches.store";
import { AppToastService } from "src/app/core/services/app-toast.service";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { CompanyService } from "src/app/core/services/company.service";
import { BenefitsService } from "src/app/core/services/portal-admission/benefits.service";
import { EmployeesHiringService } from "src/app/core/services/portal-admission/employees-hiring.service";
import { Categories } from "../../../core/models/categories.enum";

@Component({
  selector: "app-funeral-assistance-accordion",
  templateUrl: "./funeral-assistance-accordion.component.html",
  styleUrls: ["./funeral-assistance-accordion.component.scss"],
})
export class FuneralAssistanceAccordionComponent {
  @Input() benefits;
  constructor(
    private toast: AppToastService,
    private modalService: NgbModal,
    private companyStore: CompanyStore,
    private service: CompanyService,
    private router: Router,
    private benefitsService: BenefitsService,
    private authService: AuthenticationService,
    private employeesHiringService: EmployeesHiringService
  ) {}
  employeeId;
  benefitDescription: string;
  discountValue: string;
  hiringProcessId;
  benefitsValue$: Observable<any>;
  benefit: any;
  selected: boolean;
  discount: string;

  setBenefitChoice(wantsBenefit: boolean): void {
    this.benefit.wantTheBenefit = wantsBenefit;
  }

  ngOnInit(): void {
    this.employeeId = this.authService.currentUser().payload.employeeId;
    // this.getEmployeesHiring();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getBenefits(changes?.benefits?.currentValue);
  }

  // getEmployeesHiring() {
  //   this.employeesHiringService
  //     .getEmployeesHiring(this.employeeId)
  //     .subscribe((res: any) => {
  //       const id = res.hiringProcessId;
  //       this.hiringProcessId = id;

  //       this.getBenefits(id);
  //     });
  // }

  getBenefits(benefits:any) {
    // this.benefitsService.getBenefits(id).subscribe(
    // (response: any) => {
    if (!benefits) return;
    const response = benefits;
    if (response.benefitTypes && response.benefitTypes.length > 0) {
      for (const type of response.benefitTypes) {
        const foundBenefit = type.benefitList.find(
          (benefit) => benefit.categoryId === Categories.Funeral
        );
        if (foundBenefit) {
          this.benefit = foundBenefit;
          this.selected = foundBenefit.wantTheBenefit;
          this.discountValue = foundBenefit.holderDiscount;
          this.discount = foundBenefit.holderDiscount > 0 ? "Sim" : "Não";
          break;
        }
      }
    }
    //   },
    //   (error) => {
    //     console.error(
    //       "Error fetching benefits:",
    //       error.message || JSON.stringify(error)
    //     );
    //   }
    // );
  }
}
